export enum ExtendedKeyVersion {
  Public,
  Private
}
